export const eventGTM = {
    emit: (event: string, data: any = {}) => {
        if (!window.dataLayer) window.dataLayer = [];
        window.dataLayer?.push({
            event: event,
            ...data,
        } as never);
    },
};
